<template>
    <div class="basic-page">
        <BreadCrumb class="breadcrumb">
            <slot name="breadcrumb" />
        </BreadCrumb>

        <section class="basic-title">
            <slot name="title">
                <h1 class="default-title">{{ title }}</h1>
                <slot name="post-title" />
            </slot>
        </section>

        <section class="basic-body">
            <slot />
        </section>
    </div>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';

export default {
    components: { BreadCrumb },
    props: {
        title: { type: String, default: '' },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/foundation/_mixin.scss';

.basic-page {
    margin: 0 auto;
    padding: 1.7rem 4rem 6rem;
    width: 100%;
    max-width: 1260px;
    overflow: hidden;
    display: grid;
    row-gap: 1.3rem;
    grid-template-rows: 1.5rem auto minmax(0, 1fr);
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas:
        'breadcrumb'
        'title'
        'body';
    background-color: #fff;

    @include mq() {
        padding: 3rem 2rem;
    }
}

.breadcrumb {
    grid-area: breadcrumb;
    align-self: center;
}
.basic-title {
    grid-area: title;
}
.basic-body {
    grid-area: body;
    position: relative;
    margin-top: 0.5rem;
}
.default-title {
    display: inline-block;
    margin: 0;
    font-size: 2.6rem;
    font-weight: bold;
    @include mq() {
        font-size: 2rem;
    }
}
</style>
